import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardData } from "../../types/pages/dashboard";

export type DashboardRangePayload = {
  startDate: string; // ISO YYYY-MM-DD
  endDate: string;   // ISO YYYY-MM-DD
};

interface DashboardState {
  data: DashboardData | null;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // Payload is optional so existing callers still compile; saga falls back to
    // the default 7-day window when omitted.
    fetchDashboard: (_state, _action: PayloadAction<DashboardRangePayload | undefined>) => {},
    fetchDashboardStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess: (state, action: PayloadAction<DashboardData>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDashboardFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDashboardError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchDashboard,
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  clearDashboardError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
